import { isBrowser } from 'src/libs/wa/utils/env';
// 宿のhttps://github.com/wamazing/wamazing-yado-web/blob/develop/src/helpers/browser_helper.ts から引用
export function isWechat(): boolean {
  if (!isBrowser()) return false;
  return /micromessenger/i.test(navigator.userAgent);
}
